import { Emoji } from './Emoji/Emoji';
import './emojis.css';

interface EmojisProps {
    forRacer: string;
}

export const Emojis = ({ forRacer }: EmojisProps) => (
    <div className="emojis">
        <Emoji emoji="celebration" />
        <Emoji emoji="flag" />
        <Emoji emoji="shite" />
        <Emoji emoji={`${forRacer}-win`} />
        <Emoji emoji={`${forRacer}-lose`} />
    </div>
);
